
import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Globe, Phone, Mail } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white pt-24 pb-12 border-t border-sand-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-16 mb-20">
          <div className="col-span-1 md:col-span-1">
             <Link to="/" className="inline-block mb-8">
                <img 
                  src="/logo.png" 
                  alt="PrimeConnect Logo" 
                  className="h-14 w-auto mb-4"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    target.parentElement!.innerHTML += '<div class="flex items-center space-x-2"><div class="w-8 h-8 bg-gradient-to-br from-prime-blue to-prime-green rounded-lg"></div><span class="text-xl font-bold text-prime-dark">Prime<span class="font-light">Connect</span></span></div>';
                  }}
                />
              </Link>
              <p className="text-slate-500 text-sm leading-relaxed mb-8 font-medium">
                L'excellence opérationnelle alliée à l'intelligence émotionnelle. Votre extension stratégique pour conquérir de nouveaux marchés.
              </p>
              <div className="flex space-x-5">
                <a 
                  href="https://www.linkedin.com/company/primeconnect-sarl/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-sand-300 flex items-center justify-center text-slate-400 hover:bg-prime-blue hover:text-white hover:border-prime-blue transition-all"
                  title="Suivez-nous sur LinkedIn"
                >
                  <Linkedin size={18} />
                </a>
              </div>
          </div>

          <div>
            <h4 className="text-prime-dark font-bold mb-8 uppercase tracking-widest text-xs">Expertises</h4>
            <ul className="space-y-4 text-sm text-slate-500 font-semibold">
              <li><Link to="/solutions" className="hover:text-prime-blue transition-colors">Service Client & SAV</Link></li>
              <li><Link to="/solutions" className="hover:text-prime-blue transition-colors">Vente & Acquisition</Link></li>
              <li><Link to="/solutions" className="hover:text-prime-blue transition-colors">Support Technique</Link></li>
              <li><Link to="/solutions" className="hover:text-prime-blue transition-colors">BPO & Modération</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-prime-dark font-bold mb-8 uppercase tracking-widest text-xs">Société</h4>
            <ul className="space-y-4 text-sm text-slate-500 font-semibold">
              <li><Link to="/carrieres" className="hover:text-prime-blue transition-colors">Carrières</Link></li>
              <li><Link to="/contact" className="hover:text-prime-blue transition-colors">Audit ROI</Link></li>
              <li><Link to="/contact" className="hover:text-prime-blue transition-colors">Mentions Légales</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-prime-dark font-bold mb-8 uppercase tracking-widest text-xs">Direct</h4>
            <ul className="space-y-6 text-sm text-slate-500">
              <li className="flex items-start group">
                <Phone className="w-5 h-5 mr-4 text-prime-blue shrink-0" />
                <span className="font-bold group-hover:text-prime-blue transition-colors">+33 7 57 93 93 10</span>
              </li>
              <li className="flex items-start group">
                <Mail className="w-5 h-5 mr-4 text-prime-blue shrink-0" />
                <span className="font-bold group-hover:text-prime-blue transition-colors">contact@primeconnect.biz</span>
              </li>
              <li className="text-xs text-slate-400 mt-6 italic bg-sand-100 p-4 rounded-xl border border-sand-200">
                Hubs connectés : Paris, Montréal, Yaoundé.
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-10 border-t border-sand-300 flex flex-col md:flex-row justify-between items-center text-xs text-slate-400 font-bold uppercase tracking-widest space-y-6 md:space-y-0">
          <p>© 2026 conçu avec amour par PRIMECONNECT SARL.</p>
          <div className="flex space-x-8">
            <a href="#" className="hover:text-prime-blue transition-colors">Confidentialité</a>
            <a href="#" className="hover:text-prime-blue transition-colors">RGPD</a>
            <a href="#" className="hover:text-prime-blue transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
